import { Component, Output, EventEmitter, OnInit, AfterViewInit,  ViewChild, ElementRef, Inject, AfterContentInit, OnDestroy, Testability } from '@angular/core';
import { ArticleService } from '../../article/article.service';
import { NavService } from '../../header/nav/nav.service';
import { APP_CONFIG, AppConfig } from '../../config/app.config.module';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BreadcrumbService } from '../../header/breadcrumb/breadcrumb.service';

import 'rxjs/add/operator/switchMap';
import { ISubscription } from 'rxjs/Subscription';
import { TopnavService } from '../../header/topnav/topnav.service';
import { SharedService } from '../../common/shared.service';


/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 28th 2018
 * 
 * Description: Component class for Archive Category - archive/category/:id
 **/

@Component({
  selector: 'gosg-archivecategory',
  templateUrl: './archivecategory.component.html',
  styleUrls: ['./archivecategory.component.css']
})
export class ArchivecategoryComponent implements OnInit, AfterViewInit, OnDestroy {

  lang = this.lang;
  langId = this.langId;
  statusID: any;
  langIdVal: string;
  subID: number;
  moduleName: string;
  
  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  @ViewChild('textarea') textarea: ElementRef;
  @Output() menuClick = new EventEmitter();

  breadcrumb: any;
  isValid: any;
  topicID: number;
  articles: any[];

  articleData: any;
  @Output() langChange = new EventEmitter();
  public loading = false;
  constructor(private sharedService: SharedService, public articleService: ArticleService, private topnavservice: TopnavService, private route: ActivatedRoute, private navService: NavService, private translate: TranslateService, private router: Router, private breadcrumbService: BreadcrumbService, @Inject(APP_CONFIG) public config: AppConfig) {
    this.lang = translate.currentLang;
    this.langId = 1;

    this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // this.sharedService.errorHandling(event, (function(){
        const myLang = this.translate.currentLang;
        if (myLang === 'en') {
           this.lang = 'en';
           this.langId = 1;
           this.moduleName = this.router.url.split('/')[2];
           this.topicID = parseInt(this.router.url.split('/')[3]);
        }
        if (myLang === 'ms') {
          this.lang = 'ms';
          this.langId = 2;
          this.moduleName = this.router.url.split('/')[2];
          this.topicID = parseInt(this.router.url.split('/')[3]);
          this.subID = parseInt(this.router.url.split('/')[4]);
        }

        if(this.topnavservice.flagLang){

          if(this.moduleName == 'subcategory'){
            this.navService.triggerSubArticleOther(this.subID, this.langId,'archive', 'noaudit');
          }else if(this.moduleName == 'content'){
            this.navService.triggerContentOther(this.subID, this.langId,'archive', 'noaudit');
          }else{
            this.navService.triggerArticleOthers(this.moduleName,  this.langId, this.topicID, 'archive', 'noaudit');
          }
        }

          setTimeout(()=>{
            this.translate.get('pageTitle.home').subscribe((title:string) => {
              title = title + this.generateTitle();
              this.sharedService.setTitle(title);
            }); 
          },500);

    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
    });

  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }

  ngOnInit() {

    if(localStorage.getItem('langID')){
      this.langIdVal = localStorage.getItem('langID');
    }else{
      this.langIdVal = this.langId;
    }
    
    this.articleData = this.articleService.getArchive();
    this.moduleName = this.router.url.split('/')[2];
    this.topicID = parseInt(this.router.url.split('/')[3]);
    setTimeout(()=>{
      this.navService.triggerArticleOthers(this.moduleName, localStorage.getItem('langID'), this.topicID, 'archive');
    });
  }

  ngAfterViewInit() {
      //alert('masuk');
        // Get Title and Sent to GA
      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = title + this.generateTitle();
          this.sharedService.setTitleAndGtag(title);
        }); 
      },500);

      this.sharedService.loadFontSizeData();

  }

  generateTitle() {
    let title = '';
    let i = 0;
    var breadcrum =this.articleService.archives.map((articles)=>{
        return articles.breadcrum;
    })
    //console.log(breadcrum);

    for (let index=0; index < breadcrum.length; index++) { 
      if (breadcrum[index]) {
        let bread = breadcrum[index];
        bread.forEach((item) => {
            if (i == 0) {
              title = title+item.breadcrumName;  
            } else {
              title = title+' | '+ item.breadcrumName;
            }
            i++;
        });
      } 
    }
    return title;    
  }


   getTheme(){
        return localStorage.getItem('themeColor');
    }

    clickSideMenu(e, status, url){
      this.navService.loader = true;
      this.statusID = status;
      // this.navService.getSubArticleUrlOthers(e.categoryCode, localStorage.getItem('langID'), url);
      // this.navService.triggerSubArticleOther(e.categoryCode, localStorage.getItem('langID'), url);
      this.router.navigate(['/archive/subcategory', e.categoryCode]);
      event.preventDefault();
    }

    clickSideMenuOthers(e, status, url){
      this.navService.loader = true;
      this.statusID = status;
      // this.navService.getSubArticleUrlOthers(e.categoryCode, localStorage.getItem('langID'), url);
      // this.navService.triggerSubArticleOther(e.categoryCode, localStorage.getItem('langID'), url);
      this.router.navigate(['/archive/subcategory', e.categoryCode]);
      event.preventDefault();
    }


    clickSideMenuSubCategory(e, status, url){
      this.navService.loader = true;
      this.statusID = status;
      // this.navService.getSubArticleUrlOthers(e, localStorage.getItem('langID'), url);
      // this.navService.triggerSubArticleOther(e, localStorage.getItem('langID'), url);
      this.router.navigate(['/archive/subcategory', e]);
      event.preventDefault();
    }


    clickContentFromMenu(pId, aId, status){
      this.navService.loader = true;

      this.statusID = status;
      // this.navService.triggerContentOther(aId, localStorage.getItem('langID'), status);
      // this.navService.getContentUrlOther(aId, localStorage.getItem('langID'), status);
      this.router.navigate(['/archive/content', aId]);
      event.preventDefault();
    }


    triggerArticle(moduleName, lang, topicID){
        this.route.paramMap
        .switchMap((params: ParamMap) =>
        this.navService.getArticleData(moduleName, lang, topicID))
        .subscribe(resSliderData => {
            this.articles = resSliderData;
            this.breadcrumb = this.breadcrumbService.getBreadcrumb();
            this.isValid = this.breadcrumbService.isValid = true;
            this.breadcrumb = this.breadcrumb.name = '';
        });
    }

    getModule(data){
      let a = data.split("/");
      return a[1];
    }

    getID(data){
      let a = data.split("/");
      return a[2];
    }

    checkImgData(e){
        if(e){
          const chkData = e.search('<img');
          if (chkData != -1){
              return true;
          }else{
              return false;
          }
        }

    }

}




// WEBPACK FOOTER //
// ./src/app/archive/archivecategory/archivecategory.component.ts